import React, { useEffect } from "react";

import { Button, Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";

import { trackConversion, trackEvent } from "@/components/GA.component";
import { getUrlLangPrefix } from "@/utils/Local";

import FaCheckCircle from "../assets/icons/faCheckCircle.svg";
import FaHome from "../assets/icons/faHome.svg";
import useCart from "../hooks/useCart";
import i18n from "../i18n";

const PaymentSuccess = () => {
  const { dispatch, REDUCER_ACTIONS } = useCart();
  const { t } = i18n;

  useEffect(() => {
    dispatch({ type: REDUCER_ACTIONS.RESET });
    trackConversion();
    trackEvent("purchase");

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <div className="d-flex justify-content-center align-items-center min-vh-70">
        <div className="d-flex flex-column justify-content-between align-items-center gap-3 w-50 text-center">
          <img alt={t(`success`)} src={FaCheckCircle} />
          <h1>{t("_success_payment_header")}</h1>

          <p>{t("_success_payment_description")}</p>

          <NavLink className="mt-2" to={`${getUrlLangPrefix()}/`}>
            <Button variant="outline-primary d-flex justify-content-center gap-2 ps-4 pe-4 pt-2 pb-2">
              <img alt={t(`home`)} src={FaHome} />
              <span>{t("go_to_homepage")}</span>
            </Button>
          </NavLink>
        </div>
      </div>
    </Container>
  );
};

export default PaymentSuccess;
